const verification_record = {
    not_found: 'Nie znaleziono rekordu weryfikacyjnego.',
    permission_denied: 'Odmowa dostępu, proszę ponownie się uwierzytelnić.',
    not_supported_for_google_one_tap: 'Ta API nie obsługuje Google One Tap.',
};
export default Object.freeze(verification_record);
